import { useState } from "react";
import { Copy, Check, Mail, Link2, UserPlus, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import MobileNav from "../components/MobileNav";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SendIntakePage() {
  const [copied, setCopied] = useState(false);
  const intakeLink = `${API}/client-intake`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(intakeLink);
      setCopied(true);
      toast.success("Link copied to clipboard!");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 p-4 md:p-6 lg:p-8">
      <MobileNav />
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <UserPlus className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Send Intake Link</h1>
          <p className="text-zinc-400">Share this link with your clients to collect their information</p>
        </div>

        {/* Link Card */}
        <div className="bg-zinc-900 border border-zinc-700 rounded-2xl p-6 mb-6">
          <label className="block text-sm font-medium text-zinc-400 mb-3">
            <Link2 className="w-4 h-4 inline mr-2" />
            Client Intake Form Link
          </label>
          
          <div className="flex items-center gap-3">
            <div className="flex-1 bg-zinc-800 border border-zinc-600 rounded-lg px-4 py-3 text-cyan-400 font-mono text-sm break-all">
              {intakeLink}
            </div>
            <button
              onClick={handleCopy}
              className={`px-4 py-3 rounded-lg font-medium flex items-center gap-2 transition-all ${
                copied 
                  ? 'bg-green-600 text-white' 
                  : 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white hover:from-teal-600 hover:to-cyan-600'
              }`}
            >
              {copied ? (
                <>
                  <Check className="w-5 h-5" />
                  Copied!
                </>
              ) : (
                <>
                  <Copy className="w-5 h-5" />
                  Copy
                </>
              )}
            </button>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-zinc-900/50 border border-zinc-700 rounded-xl p-6 mb-6">
          <h3 className="text-lg font-semibold text-white mb-4">How it works:</h3>
          <ol className="space-y-3 text-zinc-300">
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-teal-500/20 text-teal-400 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</span>
              <span>Copy the link above and send it to your client via text or email</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-teal-500/20 text-teal-400 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</span>
              <span>Your client fills out their personal information on the secure form</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-teal-500/20 text-teal-400 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</span>
              <span>The information is automatically saved and ready for dispute generation</span>
            </li>
          </ol>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-2 gap-4">
          <a 
            href={intakeLink} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 px-4 py-3 bg-zinc-800 hover:bg-zinc-700 border border-zinc-600 rounded-lg text-white transition-colors"
          >
            <ExternalLink className="w-4 h-4" />
            Preview Form
          </a>
          <a 
            href={`mailto:?subject=Credit%20Repair%20Intake%20Form&body=Please%20fill%20out%20this%20form%20to%20get%20started:%20${encodeURIComponent(intakeLink)}`}
            className="flex items-center justify-center gap-2 px-4 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg text-white transition-colors"
          >
            <Mail className="w-4 h-4" />
            Email Link
          </a>
        </div>
      </div>
    </div>
  );
}
